var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeaturesMatching(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H88V88H0z",
    transform: "translate(-444 -1010) translate(444 1010)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M10.903 61.295l-3.039-.474c-.626-.099-.996-.465-.82-.816l12.595-25.202c.175-.35.831-.557 1.458-.459l3.038.475c.627.098.997.465.821.816L12.361 60.837c-.176.35-.832.557-1.458.458",
    transform: "translate(-444 -1010) translate(444 1010) translate(13 13)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M38.314 61.295l2.87-.474c.591-.099.94-.465.775-.816L30.063 34.803c-.165-.35-.785-.557-1.377-.459l-2.87.475c-.591.098-.94.465-.775.816l11.896 25.202c.166.35.785.557 1.377.458",
    transform: "translate(-444 -1010) translate(444 1010) translate(13 13)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC727",
    d: "M50 25c0 13.807-11.193 25-25 25S0 38.807 0 25 11.193 0 25 0s25 11.193 25 25",
    transform: "translate(-444 -1010) translate(444 1010) translate(13 13)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3677D6",
    d: "M42 25c0 9.389-7.611 17-17 17S8 34.389 8 25 15.611 8 25 8s17 7.611 17 17",
    transform: "translate(-444 -1010) translate(444 1010) translate(13 13)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    d: "M34 25c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9 9 4.03 9 9",
    transform: "translate(-444 -1010) translate(444 1010) translate(13 13)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E57467",
    d: "M30 25c0 2.762-2.239 5-5 5-2.762 0-5-2.238-5-5s2.238-5 5-5c2.761 0 5 2.238 5 5",
    transform: "translate(-444 -1010) translate(444 1010) translate(13 13)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M53.55 10.348L54.176 11.666 68 4.456 63.514 4.215 66.036 0.32 52.212 7.53 52.84 8.853 30.534 20.498 29.904 19.176 25 24.32 31.874 23.316 31.245 21.993 53.55 10.348",
    transform: "translate(-444 -1010) translate(444 1010) translate(13 13)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesMatching);
export default __webpack_public_path__ + "static/media/features-matching.a08b2867.svg";
export { ForwardRef as ReactComponent };